// @flow
import client from '../../client'

// API Endpoint
export const REGISTER_ENDPOINT_V2 = '/auth/users/'

/**
 * Register an user
 * @param  {Object} data User data
 * @param  {string} data.email User email
 * @param  {string} data.password User password
 * @param  {string} [data.first_name] User first name
 * @param  {string} [data.last_name] User last name
 * @param  {string} [data.country_code_name] User country code name
 * @param  {string} [data.phone_number] User phone number
 * @return {Promise|Error} A resolved Promise with the server response or Rejected with an Error
 */
export const register = (data: {
  email: string,
  password: string,
  first_name?: string,
  last_name?: string,
  country_code_name?: string,
  phone_number?: string,
}): Promise<any> => client.post(REGISTER_ENDPOINT_V2, { body: data })

export default register
